
<div [formGroup]="orderForm" class="full-width"  >

  <button mat-raised-button color="primary" (click)="addParameter()">Criar um novo parametro</button>


  <div formArrayName="items" *ngFor="let item of _items.controls; let i = index;">
    <div [formGroupName]="i">

      <mat-card class="full-width" >
        <div class="row">

          <div class="col-md-1 ">
            <mat-form-field>
              <input matInput formControlName="order" placeholder="Ordem">
            </mat-form-field>
          </div>
          <div class="col-md-2 ">
            <mat-form-field>
              <input matInput formControlName="title" placeholder="Titulo">
            </mat-form-field>
          </div> 
           <div class="col-md-2 ">
            <mat-form-field>
              <input matInput formControlName="description" placeholder="Descrição">
            </mat-form-field>
          </div>
        <div class="col-md-2 ">
          <mat-form-field>
            <input matInput formControlName="link" placeholder="Link">
          </mat-form-field>
        </div>

  

        <div class="col-md-1">
          <button mat-icon-button color="primary" (click)="remove(i)" aria-label="Remover">
            <mat-icon>remove_circle</mat-icon>
          </button>
        </div>
        
        </div>
      </mat-card>
      <br>
    </div>

  </div>

  </div>
